// Ensure uris have trailing slashes
const appendTrailingSlash = (uri: string): string => (
  uri[uri.length - 1] === '/' ? uri : `${uri}/`
);

export default appendTrailingSlash;
